import "./ChangeRelatedCard.scss";
import { Col, LOGOS, Region, Row } from "@/components";
import { Divider } from "@/components/ui/Divider";

type ChangeRelatedCardProps = {
  title: string;
  region: Region;
  isSelected?: boolean;
  mainLabel?: string;
  regionLabel?: string;
};

export const ChangeRelatedCard = ({
  title,
  isSelected = false,
  region,
  mainLabel = "Fascicolo Sanitario",
  regionLabel = "Salute",
}: ChangeRelatedCardProps) => {
  const NationalIcon = LOGOS["nazionale"];
  const RegionIcon = LOGOS[region];

  const firstLetterUppercase = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  return (
    <Col
      className={`position-relative change-related-card-container text-slate-20 ${isSelected ? "change-related-card-container-selected" : ""}`}
    >
      <Row
        className={"change-related-title"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <p className={"fw-semibold fs-4 md-fs-3 "}>{title}</p>
      </Row>
      <Row
        className="change-related-card-row"
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Row className={"change-related-icons"}>
          <NationalIcon className="national-icon" width={27} height={44} />
          <Divider
            className="divider-icon"
            bg="border-divider"
            direction="vertical"
          />
          <RegionIcon width={44} height={44} />
        </Row>

        <h1 className="fs-6 md-fs-custom fw-normal text-align-center">
          <p>{mainLabel}</p>
          <p style={{ fontWeight: "bold" }}>
            {regionLabel} {firstLetterUppercase(region)}
          </p>
        </h1>
      </Row>
    </Col>
  );
};
